import GatewaysReports from "./Gateways-reports"
import UsersReports from "./Users-reports"

export {
    UsersReports,
    GatewaysReports
}